const MODULE_NAME = 'menu'
export const SET_MENU = `${MODULE_NAME}/SET_MENU`

export const updateMenuList = value => dispatch => {
  dispatch({
    type: SET_MENU,
    payload: { menuList: value },
  })
}
